import React from "react";
import { Form } from "react-final-form";
import { Button, Modal, TextInput } from "@truevault/aquilo";
import { requiredString } from "../../util/validation";

type EditDpoProps = {
  open: boolean;
  onClose: () => void;
  onDone: (vals: DpoValues) => void;
  values: DpoValues;
};

export type DpoValues = {
  name: string | undefined;
  email: string | undefined;
  phone: string | undefined;
  address: string | undefined;
};

export const EditDpoDialog: React.FC<EditDpoProps> = ({ open, onClose, onDone, values }) => {
  if (!open) return null;

  const handleSubmit = (vals: DpoValues) => {
    onClose();
    onDone(vals);
  };

  const validate = (vals: DpoValues) => {
    const errors = {} as { [x: string]: string };
    requiredString(vals, "name", errors);
    requiredString(vals, "email", errors);
    return errors;
  };

  return (
    <Modal
      title="Data Protection Officer"
      alignText="left"
      closeButton
      showOverlay
      onClose={onClose}
      contentContainerClasses="w-full"
      contentPadding="px-[24px] pt-5 pb-[4px]"
    >
      <Form
        onSubmit={handleSubmit}
        validate={validate}
        initialValues={values}
        render={({ handleSubmit, valid }) => (
          <form
            onSubmit={handleSubmit}
            className="flex flex-col gap-[6px]"
            style={{ marginRight: "-16px" }}
          >
            <p className="text-[16px] text-neutral-700" style={{ marginTop: "-18px" }}>
              Add contact details for your business&rsquo;s DPO below.
            </p>

            <div className="flex flex-col gap-[6px]">
              <TextInput field="name" label="Name" required autoFocus />
              <TextInput field="email" label="Email Address" type="email" required />
              <TextInput field="phone" label="Telephone number (optional)" />
              <TextInput field="address" label="Physical address (optional)" />
            </div>

            <div className="flex justify-end items-center gap-[12px]">
              <Button color="tertiary" onClick={onClose}>
                Cancel
              </Button>
              <Button color="primary" type="submit" disabled={!valid} onClick={() => {}}>
                Update
              </Button>
            </div>
          </form>
        )}
      />
    </Modal>
  );
};
